import { render, staticRenderFns } from "./iconAddresses.vue?vue&type=template&id=06e7ea89&scoped=true"
import script from "./iconAddresses.vue?vue&type=script&lang=js"
export * from "./iconAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7ea89",
  null
  
)

export default component.exports